import React from 'react';
import FontsDefault from '../../Assistant/DefaultStyle';

function OurServicesFooter() {
  return (
    <div className=' lg:w-3/12 w-full p-4'>
      <h1 className={`${FontsDefault.text4xl} font-bold text-amber`}>
        خدماتنا
      </h1>
      <div className='mt-6'>
        <p className='py-2 text-lg text-gray700'>تقديم الحملات الإعلانية على جميع المنصات</p>
        <p className='py-2 text-lg text-gray700'>وضع خطط وإستراتيجيات ناجحة بالتسويق الإلكتروني</p>
        <p className='py-2 text-lg text-gray700'>إدارة صفحات السوشيال ميديا</p>
        <p className='py-2 text-lg text-gray700'>إنشاء قنوات يوتيوب وتقديم خطط تسويقية وحل المشكلات</p>
        <p className='py-2 text-lg text-gray700'>كتابة محتوى إبداعي</p>
        <p className='py-2 text-lg text-gray700'>إنشاء هويات بصرية للعلامات التجارية</p>
      </div>
    </div>
  );
}

export default OurServicesFooter;
